

  <div class="background" >
    <div class="inset" >
      <h1>Church Applications</h1>
      <p>The list of church applications for It Is Written Bible School.
      </p>
      <div class = "horizontalLine"></div>
    </div>
    <br><br>
    <div class="inset">
      <table class='churchContainer'>
        <tr>
          <th>Church/Institution Name</th>
          <th>Pastor  </th>
          <th>Pastor's Email</th>
          <th>Phone</th>
          <th>Address</th>
          <th>Date</th>
          <th>Status</th>
        
        </tr>
        <tr *ngFor="let app of applications">
          <td>{{app.name}}</td>
          <td>{{app.pastor?.name}}</td>
          <td>{{app.pastor?.email}}</td>
          <td>{{app.phone}}</td>
          <td>{{app.address}}</td>
          <td>{{app.date | date}}</td>
          <td *ngIf=!superAdmin  >{{approved === true ? 'Approved' :  approved === false ? 'Denied' :'Not Approved'}}</td>
          <td *ngIf=!!superAdmin [ngClass]="{'approved': app?.approved, 'denied': !app?.approved}">{{app?.approved === true ? 'Approved' :  app?.approved === false ? 'Denied' :'Not Approved'}}</td>
          <td><button (click)="approve(app?.id)" class=approve >Approve</button></td>
          <td><button (click)="deny(app?.id)" class=deny>Deny</button></td>
        </tr>
          
      
      
    </table>
  </div>